// /src/api/roles.api.js
import axios from "./axios"; // tu instancia axios existente
import { getToken } from "../store/auth.store";



// ====================== USUARIOS ======================

// Obtener todos los usuarios
export async function getUsuarios() {
  try {
    const token = getToken();
    const response = await axios.get("/users/", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data; // array de usuarios
  } catch (error) {
    console.error("Error al obtener usuarios:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
}

// ====================== ROLES ======================

// Obtener todos los roles
export async function getRoles() {
  try {
    const token = getToken();
    const response = await axios.get("/roles/", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data; // array de roles
  } catch (error) {
    console.error("Error al obtener roles:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
}

// Crear un nuevo rol
export async function createRole({ name }) {
  try {
    const token = getToken();
    const response = await axios.post(
      "/roles/",
      { name },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error("Error al crear rol:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
}

// Asignar un rol a un usuario
export async function assignRoleToUser(userId, roleId) {
  try {
    const token = getToken();
    const response = await axios.post(
      `/users/${userId}/roles`,
      { role_id: roleId },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error("Error al asignar rol:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
}

// ✅ NUEVO: Eliminar un rol de un usuario
export async function removeRoleFromUser(userId, roleId) {
  try {
    const token = getToken();
    const response = await axios.delete(
      `/users/${userId}/roles/${roleId}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
  } catch (error) {
    console.error("Error al eliminar rol de usuario:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
}

// Eliminar un rol del sistema
export async function deleteRole(roleId) {
  try {
    const token = getToken();
    const response = await axios.delete(`/roles/${roleId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error("Error al eliminar rol:", error.response?.data || error.message);
    throw error.response?.data || error;
  }
}
